module.exports = __webpack_public_path__ + "static/img/6.417a5a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/在线教育/6.png
// module id = dP53
// module chunks = 1